module.exports = __webpack_public_path__ + "static/media/car6.c2ee26bb.svg";